const privateCls = [
  '.dhq_cell',
  '.dhq_row',
  '.dhq_hr',
  '.dhq_vr',
  '.dhq_button',
  '.dhq_grid',
  '.dhq_grid_item',
  '.dhq_badge'
];

function initEventHandler() {
  editor.Config['privateClasses'] = privateCls;

  //// for selecting component after droped to canvas
  editor.on('block:drag:stop', function(model) {
    editor.select(model);
  });

  //// for making default block classes private
  editor.on('selector:add', selector => {
    if (privateCls.indexOf(selector.getFullName()) >= 0) {
      selector.set({ private: 1 });
    }
  });
}

export default {
  initEventHandler: initEventHandler
};
